"use client";

import Image from "next/image";
import { useState } from "react";
import { LinkButton } from "../ui";
import styles from "./project.module.css";

type ProjectItem = {
  title: string;
  description: string;
  image: string;
  alt: string;
  objectPosition?: string;
};

const PROJECTS: ProjectItem[] = [
  {
    title: "Website Thẩm mỹ",
    description:
      "Giao diện sang trọng, tinh tế, tôn vinh vẻ đẹp và thương hiệu. Tối ưu trải nghiệm người dùng với hình ảnh chất lượng cao, bố cục hài hoà và màu sắc thu hút.",
    image: "/assets/sdtc-image/trang-chu/project/drtuananh.webp",
    alt: "Website thẩm mỹ",
  },
  {
    title: "Website bán hàng",
    description:
      "Giao diện hiện đại, thu hút với bố cục tinh gọn. Màu sắc hài hòa, tạo cảm giác tin cậy và thúc đẩy hành vi mua sắm. Tích hợp giỏ hàng thông minh và thanh toán nhanh chóng.",
    image: "/assets/sdtc-image/trang-chu/project/ruou.webp",
    alt: "Website bán hàng",
  },
  {
    title: "Website phong thuỷ",
    description:
      "Thiết kế trang nhã, cân bằng giữa yếu tố truyền thống và hiện đại. Gam màu xanh biển ấm tạo cảm giác bình yên, tin cậy.",
    image: "/assets/sdtc-image/trang-chu/project/huyenhocviet.webp",
    alt: "Website phong thuỷ",
    objectPosition: "center 15%",
  },
];

export default function ProjectSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const goToNext = () => {
    setActiveIndex((prev) => (prev + 1) % PROJECTS.length);
  };

  const goToIndex = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <section className={styles.project}>
      <div className={styles.projectContent}>
        <p className={styles.projectTag}>Dự án</p>
        <h2>Thành công vượt bậc</h2>
        <p>
          Chúng tôi tự hào khi mỗi dự án hoàn thành không chỉ đáp ứng yêu cầu mà còn mang lại giá trị
          thực tế cho khách hàng. Thành công của dự án là sự kết hợp giữa sáng tạo, chất lượng và cam
          kết của chúng tôi.
        </p>
      </div>

      <div className={styles.swapSection}>
        <div className={styles.swapSticky}>
          <div
            className={styles.projectSwapFrame}
            onClick={goToNext}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                goToNext();
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Nhấn để chuyển sang dự án tiếp theo"
          >
            {PROJECTS.map((project, index) => (
              <article
                key={project.image}
                className={`${styles.swapCard} ${index === activeIndex ? styles.active : ""}`}
                aria-hidden={index !== activeIndex}
              >
                <Image
                  src={project.image}
                  alt={project.alt}
                  className={styles.projectImg}
                  style={{ objectPosition: project.objectPosition ?? "center top" }}
                  width={1200}
                  height={720}
                  quality={75}
                  priority={index === 0}
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 90vw, 1200px"
                />

                <div className={styles.projectOverlay}>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </article>
            ))}
          </div>

          <div className={styles.swapDots}>
            {PROJECTS.map((project, index) => (
              <button
                key={project.title}
                type="button"
                className={`${styles.dot} ${index === activeIndex ? styles.dotActive : ""}`}
                onClick={() => goToIndex(index)}
                aria-label={`Chuyển đến dự án ${index + 1}: ${project.title}`}
                aria-current={index === activeIndex ? "true" : undefined}
              />
            ))}
          </div>
        </div>
      </div>

      <LinkButton href="/doi-ngu" variant="outline" aria-label="Khám phá đội ngũ của chúng tôi">
        Khám phá đội ngũ của chúng tôi
      </LinkButton>
    </section>
  );
}
